import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../lib/queryKeys';
import { fetchTags, fetchTagsMine } from '../api/tags.js';

/**
 * Tag directory — long staleTime, kept fresh by targeted invalidation.
 * TRACK-B-1b: the old premise («rarely changes — admin/TL-gated writes») is dead.
 * ANY manager now creates a tag implicitly at intake (create-lead, CSV import,
 * bulk-tag, the blogger card), so every create-carrying mutation invalidates
 * `queryKeys.tags.all` on success — the seven seats of spec §3.5. Without that a new
 * tag would be invisible in the directory and in the filter bar for up to 5 minutes.
 *
 * Those same seven invalidations also refresh `useTagsMine`: its key `['tags','mine']`
 * is a prefix-extension of `['tags']`, and react-query v5 invalidates by key PREFIX, so
 * one call covers both entries. The key shape is chosen for exactly that reason — do
 * not flatten it to a sibling like `['tagsMine']`, which the seats would then miss.
 */
export function useTags () {
  return useQuery({ queryKey: queryKeys.tags.all, queryFn: fetchTags, staleTime: 5 * 60_000 });
}

/**
 * The «Мои» filter bar's narrowed directory (owner ruling 2026-08-24): only tags
 * actually present on leads inside the caller's role scope. Separate cache entry from
 * `useTags`, which stays global for the intake combobox's dedup-by-text; both are
 * invalidated together by the §3.5 seats.
 */
export function useTagsMine () {
  return useQuery({ queryKey: queryKeys.tags.mine, queryFn: fetchTagsMine, staleTime: 5 * 60_000 });
}
